import r from '../Utils/fetch';

const w: any = window;
const getBaseUrl = () =>
	w.API_CONNECTORS_CONFIG_URL || w.API_CONNECTORS_V2_URL || 'http://localhost:8080';

export type BetaRequestStatus = 'pending' | 'approved' | 'rejected';

export interface ConnectorBetaRequest {
	id: number;
	userId: string;
	userEmail: string;
	userName: string;
	projectFolderId: string;
	sku: string;
	connectorName: string;
	accountsToTest: number;
	reason: string;
	status: BetaRequestStatus;
	decidedBy?: string;
	decidedAt?: string;
	decisionReason?: string;
	createdAt: string;
	updatedAt: string;
}

export const listBetaRequests = async (
	sku: string,
	statusFilter?: BetaRequestStatus
): Promise<ConnectorBetaRequest[]> => {
	const res = await r<{ betaRequests: ConnectorBetaRequest[] }>({
		url: `${getBaseUrl()}/v1/admin/connectors/${sku}/beta-requests`,
		method: 'GET',
		data: statusFilter ? { status: statusFilter } : undefined,
	});
	return res.betaRequests || [];
};

export const listAllBetaRequests = async (
	statusFilter?: BetaRequestStatus
): Promise<ConnectorBetaRequest[]> => {
	const res = await r<{ betaRequests: ConnectorBetaRequest[] }>({
		url: `${getBaseUrl()}/v1/admin/beta-requests`,
		method: 'GET',
		data: statusFilter ? { status: statusFilter } : undefined,
	});
	return res.betaRequests || [];
};

// addBetaTester accorde manuellement l'accès beta d'un connecteur à un user
// (flux push admin). userId = ID numérique qm_user.id (celui de la resource
// react-admin `users`) ; le backend le résout en Firebase UID + email/nom.
export const addBetaTester = (
	sku: string,
	userId: number | string
): Promise<ConnectorBetaRequest> =>
	r({
		url: `${getBaseUrl()}/v1/admin/connectors/${sku}/beta-testers`,
		method: 'POST',
		data: { userId: String(userId) },
	});

export const decideBetaRequest = (
	id: number,
	status: 'approved' | 'rejected',
	reason?: string
): Promise<ConnectorBetaRequest> =>
	r({
		url: `${getBaseUrl()}/v1/admin/beta-requests/${id}`,
		method: 'PATCH',
		data: reason ? { status, reason } : { status },
	});
